import React from "react";

function NoticeTag({
  title,
  color,
  backgroundColor,
  variant,
  className,
  small = false,
}) {
  if (variant === "blue") {
    color = "#0BA7FF";
    backgroundColor = "#CEEDFF";
  }
  return (
    <span
      className={`badge ${className}`}
      style={{
        borderRadius: "30px",
        color: color || "#A6A3A3",
        backgroundColor: backgroundColor || "#F4F5F5",
        fontSize: small ? "0.85rem" : undefined,
        padding: small ? "4x 1px" : undefined,
      }}
    >
      {title}
    </span>
  );
}

export default NoticeTag;
